import React from 'react';
import PropTypes from 'prop-types';
import css from './MultipleChoiceField.scss'
import Icon from 'SF/MaterialIcon';
import RadioButton from './RadioButton';

export default class MultipleChoiceField extends React.Component {

  changeHandler = (e, index) => {
    let updatedValue = {
      option: e.target.value
    };
    if (this.props.options[index].value !== e.target.value) return;
    this.props.setValue(updatedValue)
  }

  isRadioButtonSelected = (value) => {
    if(!this.props.value) return false;
    return (this.props.value.option === value)
  }

  render() {
    const { options, isReadOnly, hasError, questionNumber, questionText } = this.props
    return (
      <>
        <div className={css['multiple-choice-wrapper']} role="radiogroup" aria-label={questionText}>
          {options.map((option, index) =>
            <RadioButton
              key={index}
              value={option.value}
              label={option.display}
              checked={this.isRadioButtonSelected(option.value)}
              onChange={(e) => this.changeHandler(e, index)}
              disabled={isReadOnly}
              name={`multipleChoice_${questionNumber}`}
            />
          )}
        </div>
        {hasError && !isReadOnly && (
          <div className={css['input-error-message-block']} role="alert">
            <Icon icon="error" /><p>Invalid option selected</p>
          </div>
        )}
      </>
    )
  }
}

MultipleChoiceField.propTypes = {
  value: PropTypes.shape({
    option: PropTypes.string,
    value: PropTypes.any
  }),
  options: PropTypes.array,
  isRequired: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func,
  questionNumber: PropTypes.number,
  questionText: PropTypes.string
}
